import { createReducer } from 'deox';

import {
  TAddPlayerToClassResponse,
  TCreateClassResponse,
  TDeleteClassResponse,
  TGetClassResponse,
  TGetClassesResponse,
  TRemovePlayerFromClassResponse,
  TUpdateClassResponse,
} from '@/services/api/class';
import {
  addPlayerToClassAction,
  createClassAction,
  deleteClassAction,
  getClassAction,
  getClassesAction,
  removePlayerFromClassAction,
  updateClassAction,
} from '@/redux/actions';
import { addPlayerToClassUpdateState } from './add-player-to-class';
import { createClassUpdateState } from './create-class';
import { deleteClassUpdateState } from './delete-class';
import { getClassUpdateState } from './get-class';
import { getClassesUpdateState } from './get-classes';
import { removePlayerFromClassUpdateState } from './remove-player-from-class';
import { updateClassUpdateState } from './update-class';

export type TClassState = {
  addPlayerToClassResponse?: TAddPlayerToClassResponse;
  createClassResponse?: TCreateClassResponse;
  deleteClassResponse?: TDeleteClassResponse;
  getClassResponse?: TGetClassResponse;
  getClassesResponse?: TGetClassesResponse;
  removePlayerFromClassResponse?: TRemovePlayerFromClassResponse;
  updateClassResponse?: TUpdateClassResponse;
};

const initialState: TClassState = {
  addPlayerToClassResponse: undefined,
  createClassResponse: undefined,
  deleteClassResponse: undefined,
  getClassResponse: undefined,
  getClassesResponse: undefined,
  removePlayerFromClassResponse: undefined,
  updateClassResponse: undefined,
};

const ClassReducer = createReducer(initialState, (handleAction) => [
  handleAction(addPlayerToClassAction.success, addPlayerToClassUpdateState),
  handleAction(createClassAction.success, createClassUpdateState),
  handleAction(deleteClassAction.success, deleteClassUpdateState),
  handleAction(getClassAction.success, getClassUpdateState),
  handleAction(getClassesAction.success, getClassesUpdateState),
  handleAction(removePlayerFromClassAction.success, removePlayerFromClassUpdateState),
  handleAction(updateClassAction.success, updateClassUpdateState),
]);

export default ClassReducer;
